import styled from "styled-components";

export const InputWrapper = styled.div``;
const InputComponent = styled.input`
    padding: 10px;
    font-size: 16px;
    letter-spacing: 1px;
    border-radius: 5px;
    border: 1px solid #e2e2e2;
    outline: 0;
`;

const Input = ({ type, value, fieldName, placeholder, onChange }) => {
    return (
        <InputComponent
            type={type} 
            placeholder={placeholder}
            value={value}
            fieldName={fieldName}
            onChange={onChange}
        />
    );
};

export default Input;